module.exports = __webpack_public_path__ + "assets/img/is-top-not.b2bd442d.svg";